import {
	Box,
	Card,
	CardHeader,
	Divider,
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TablePagination,
	TableRow,
} from "@mui/material";
import { ChangeEvent, FC, useState } from "react";

import { applyPagination } from "src/Helpers/utils";
import { IInvoice } from "src/Types/module/invoice/invoiceTypes";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import InvoiceTableRow from "./InvoiceTableRow";

interface RecentOrdersTableProps {
	className?: string;
	allInvoice: IInvoice[];
	loading: boolean;
	status: string;
	setStatus: Function;
}

const InvoiceTable: FC<RecentOrdersTableProps> = ({
	allInvoice,
	loading,
	status,
	setStatus,
}) => {
	const [page, setPage] = useState<number>(0);
	const [limit, setLimit] = useState<number>(25);

	const statusOptions = [
		{
			id: "all",
			name: "All",
		},
		{
			id: "pending",
			name: "Pending",
		},
		{
			id: "cancelled",
			name: "Cancelled",
		},
		{
			id: "paid",
			name: "Paid",
		},
		{
			id: "reported",
			name: "Reported",
		},
	];

	const handlePageChange = (event: any, newPage: number): void => {
		setPage(newPage);
	};

	const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
		setLimit(parseInt(event.target.value));
	};

	const paginatedData = applyPagination(allInvoice, page, limit);

	return (
		<Card>
			<CardHeader
				action={
					<Box width={150}>
						<FormControl fullWidth variant="outlined">
							<InputLabel>Status</InputLabel>
							<Select
								value={status}
								onChange={(e) => setStatus(e.target.value)}
								label="Status"
								autoWidth
							>
								{statusOptions.map((statusOption) => (
									<MenuItem
										key={statusOption.id}
										value={statusOption.id}
									>
										{statusOption.name}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Box>
				}
				title="All Invoices"
			/>
			<Divider />
			<TableContainer>
				<Table sx={{ position: "relative", minHeight: "250px" }}>
					<TableHead>
						<TableRow>
							<TableCell>Invoice ID</TableCell>
							<TableCell>Invoice issue date</TableCell>
							<TableCell>Compnay name</TableCell>
							<TableCell>Total Amount</TableCell>
							<TableCell>Status</TableCell>
							<TableCell>Actions</TableCell>
						</TableRow>
					</TableHead>
					{loading ? (
						<TableLoader />
					) : paginatedData.length ? (
						<TableBody>
							{paginatedData.map((allInvoice: any) => {
								return (
									<InvoiceTableRow
										key={
											allInvoice.member_payment_invoice_id
										}
										allInvoice={allInvoice}
									/>
								);
							})}
						</TableBody>
					) : (
						<TableNotFound />
					)}
				</Table>
			</TableContainer>
			<Box p={2}>
				<TablePagination
					component="div"
					count={allInvoice.length}
					onPageChange={handlePageChange}
					onRowsPerPageChange={handleLimitChange}
					page={page}
					rowsPerPage={limit}
					rowsPerPageOptions={[25, 50, 75, 100]}
				/>
			</Box>
		</Card>
	);
};

export default InvoiceTable;
